<section *ngIf="loading">
  <div class="loading-container">
    <h3> <i class="fa fa-spinner fa-2x fa-spin"></i> </h3>
  </div>
</section>
<section *ngIf="!isProd">
  <div class="loading-container">
    <h3>Relatório somente em ambiente de produção!</h3>
  </div>
</section>
<section *ngIf="isProd && hasError">
  <div class="loading-container">
    <h2>Sentimos muito, não foi possível carregar o relatório!</h2>
    <h2>Por favor tente novamente mais tarde.</h2>
  </div>
</section>
<iframe *ngIf="isProd" id="iframeMetabaseReport" scrolling="no" class="iframe-report"
        [src]="metabaseReportUrl"
        title="Relatório de uso">
</iframe>
